module.exports = __webpack_public_path__ + "static/media/learn_icon.2065cc89.svg";